import React, { Component } from "react";
import { connect } from "react-redux";
import MobileMenu2 from "../MobileMenu2";
import min3 from "../../images/love.png";
import { removeFromCart } from "../../store/actions/action";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import HeaderTopbar from "../HeaderTopbar";
import { totalPrice } from "../../utils";
import { addUser, emptyCart } from "../../store/actions/action";
import { getAuth, signOut } from "firebase/auth";
import MyAccount from "../MyAccountPopup/MyAccountFixed";
import NotificationBell from "../NotificationBell";

class Header2 extends Component {
  state = {
    isSearchShow: false,
    isCartShow: false,
    isScrolled: false, // Track scroll state
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const isScrolled = window.scrollY > 80; // Change logo after 50px scroll
    this.setState({ isScrolled });
  };

  searchHandler = () => {
    this.setState({
      isSearchShow: !this.state.isSearchShow,
    });
  };

  cartHandler = () => {
    this.setState({
      isCartShow: !this.state.isCartShow,
    });
  };

  handleWhatsApp = () => {
    const message = encodeURIComponent("Bună, Ariana!\nNumele meu este: ");
    const whatsappUrl = `https://wa.me/40743222996?text=${message}`;
    window.location.href = whatsappUrl;
  };

  render() {
    const { isSearchShow, isCartShow, isScrolled } = this.state;

    const ClickHandler = () => {
      window.scrollTo(10, 0);
    };

    const LogoutHandler = () => {
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          toast.success(
            this.props.user.user.email +
              " successfully logged out from theOilsBabe!"
          );
          this.props.addUser([]);
          this.props.emptyCart();
        })
        .catch((error) => toast.error(error.message));
    };

    const { carts } = this.props;
    const { user } = this.props.user;

    return (
      <header id="header" className={this.props.topbarBlock}>
        {this.props.isHome && <HeaderTopbar />}
        <div className={`wpo-site-header ${this.props.hclass}`} id="home">
          <nav className="navigation navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
              <div className="col-lg-3 col-md-2" style={{ marginLeft: "10px" }}>
                <div className="navbar-header">
                  <Link onClick={ClickHandler} to="/home">
                    <img
                      src={
                        isScrolled
                          ? "../logo/logo alb no tm.png"
                          : "../logo/logo ploom.png"
                      }
                      alt="Logo"
                    />
                  </Link>
                </div>
              </div>

              <div className="col-lg-6 col-md-1 col-1">
                <div
                  id="navbar"
                  className="collapse navbar-collapse navigation-holder"
                >
                  <button className="menu-close">
                    <i className="ti-close"></i>
                  </button>
                  <ul
                    className={`nav navbar-nav mb-2 mb-lg-0 ${
                      this.state.isScrolled ? "scrolled" : "not-scrolled"
                    }`}
                  >
                    <li>
                      <Link onClick={ClickHandler} to="/">
                        Acasă
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/consultanta">
                        Consultanță
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/evenimente/mostre">
                        Mostre
                      </Link>
                    </li>
                    {/* <li>
                      <Link onClick={ClickHandler} to="/librarie">
                        Librărie
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/blog">
                        Blog
                      </Link>
                    </li> */}
                    {/* <li>
                      <Link onClick={ClickHandler} to="/contact">
                        Contact
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-2 col-2">
                <div className="header-right">
                  {/* Hamburger and PersonIcon grouped for mobile */}
                  <div className="mobile-menu-group">
                    {/* Mobile notification bell for admins only */}
                    {(user?.email === process.env.REACT_APP_ADMIN || user?.email === process.env.REACT_APP_ARI_ADMIN) && (
                      <div
                        className={`mobile-notification-bell${isScrolled ? " mobile-icon-white" : " primary-icon"}`}
                        style={{ width: 40, display: "flex", justifyContent: "center", alignItems: "center", minWidth: 40, marginRight: 20 }}
                      >
                        <NotificationBell />
                      </div>
                    )}
                    <div
                      className={`mobile-account-icon${isScrolled ? " mobile-icon-white" : " primary-icon"}`}
                      style={{ width: 40, display: "flex", justifyContent: "center", alignItems: "center", minWidth: 40 }}
                    >
                      <MyAccount logout={LogoutHandler} mobileOnly />
                    </div>
                    <div className="mobail-menu">
                      <MobileMenu2 />
                    </div>
                  </div>
                  {/* Desktop notification bell and account icon - always show between 660px and 991px */}
                  <div className="responsive-hide show-account-mid" style={{ display: "flex", alignItems: "center" }}>
                    {/* Desktop notification bell for admins only */}
                    {(user?.email === process.env.REACT_APP_ADMIN || user?.email === process.env.REACT_APP_ARI_ADMIN) && (
                      <div
                        className={`desktop-notification-bell${!isScrolled ? " primary-icon" : ""}`}
                        style={{ width: 40, display: "flex", justifyContent: "center", alignItems: "center", minWidth: 40, marginRight: 120 }}
                      >
                        <NotificationBell />
                      </div>
                    )}
                    <div
                      className={`${!isScrolled ? " primary-icon" : ""}`}
                      style={{ width: 40, display: "flex", justifyContent: "center", alignItems: "center", minWidth: 40 }}
                    >
                      <MyAccount logout={LogoutHandler} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
          <div className="header-nav-wave">
            <svg
              viewBox="0 120 1440 74"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="transparent"
                fillOpacity="1"
                d="M1440,128L1400,138.7C1360,149,1280,171,1200,165.3C1120,160,1040,140,960,134.7C880,129,800,139,720,149.3C640,160,560,160,480,154.7C400,149,320,139,240,138.7C160,139,80,149,40,154.7L0,160V0H1440Z"
                transform="scale(-1,1) translate(-1440,0)"
              ></path>
            </svg>
          </div>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    carts: state.cartList.cart,
    user: state.user,
  };
};

const ConnectedHeader2 = connect(mapStateToProps, {
  removeFromCart,
  addUser,
  emptyCart,
})(Header2);

export default ConnectedHeader2;
